//@ts-check
import React from 'react';
import Form from '../../../../../../../form';
var fontSizes = {
  options: [{
    label: 'Inherit',
    value: 'Inherit'
  }, 6, 8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72]
};

var displayFontSize = function displayFontSize(fontSize) {
  if (typeof fontSize === 'string' && fontSize.search('pt') !== -1) return fontSize.substring(0, fontSize.length - 2);else return fontSize;
};

var FontSizePicker = function FontSizePicker(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return React.createElement(Form.Input.NumericPicker, Object.assign({
    onChange: onChange
  }, fontSizes, {
    value: displayFontSize(value),
    width: 55,
    icon: "font-size",
    label: ""
  }));
};

export default FontSizePicker;